/** Win-back: people who lapsed within the last 12 months and have not renewed, worked case by case. */
import type { PersonLine, ViewDef } from "../views";

export const UNDER_6 = "Under 6 months";
export const OVER_6 = "6 to 12 months";

export const WIN_BACK: ViewDef = {
  id: "win-back",
  title: "Win-back",
  paged: false,
  queue: true,
  emails: "segment",
  columns: [
    { key: "standing", label: "Standing", kind: "standing" },
    { key: "district", label: "District", kind: "num" },
    { key: "window", label: "Window" },
    { key: "contact", label: "Last contact", kind: "date" },
    { key: "review", label: "Review", kind: "review" },
  ],
  empty: "No one to win back.",
  // The windows count the months since the lapse, not the standing (the suspended are among both): each opens its own rows.
  facts: (rows) => [
    [rows.filter((r) => r.tag === "6mo").length, "under 6 months", `window=${encodeURIComponent(UNDER_6)}`],
    [rows.filter((r) => r.tag === "12mo").length, "over 6 months", `window=${encodeURIComponent(OVER_6)}`],
  ],
};

/** The 6-month queue first, then the 12-month queue's extra people. Each person once, labelled by the nearer window. */
export function mergeWinBack(sixMonths: PersonLine[], twelveMonths: PersonLine[]): PersonLine[] {
  const byId = new Map<number, PersonLine>();
  for (const p of sixMonths) byId.set(p.id, { ...p, tag: "6mo", cells: { ...p.cells, window: UNDER_6 } });
  for (const p of twelveMonths) {
    if (!byId.has(p.id)) byId.set(p.id, { ...p, tag: "12mo", cells: { ...p.cells, window: OVER_6 } });
  }
  return [...byId.values()];
}
